
const el = document.querySelector('.grid__item.product__media-wrapper .product__media-list');
const items = el?.querySelectorAll('li');



if (el && items.length >= 3) {
  const singleItemHeight = items[0].clientHeight;

  const maxHeight = (singleItemHeight * 3) + 48;

  el.style.maxHeight = `${maxHeight}px`;

  el.style.overflowY = 'auto';
}


// Custom slider functionality on mobile
document.addEventListener('DOMContentLoaded', function () {
  // Force scroll to top on page load
  window.scrollTo(0, 0);

  const el = document.querySelector('.grid__item.product__media-wrapper .product__media-list');
  const items = el?.querySelectorAll('li');

  if (el && items.length >= 3) {
    const singleItemHeight = items[0].clientHeight;
    const maxHeight = (singleItemHeight * 3) + 48;

    el.style.maxHeight = `${maxHeight}px`;
    el.style.overflowY = 'auto';
  }

  // Custom slider functionality on mobile
  const slides = Array.from(document.querySelectorAll('.product__media-item'));
  const mediaList = document.querySelector('.product__media-list');

  if (!mediaList || slides.length === 0) return;

  let currentIndex = 0;
  let startY = 0;
  let deltaY = 0;
  let isDragging = false;

  // Create indicators
  const indicatorsContainer = document.createElement('div');
  indicatorsContainer.className = 'custom-carousel-indicators';
  mediaList.parentNode.insertBefore(indicatorsContainer, mediaList.nextSibling);

  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'custom-carousel-indicator';
    if (i === 0) dot.classList.add('active');
    dot.setAttribute('aria-label', `Slide ${i + 1} of ${slides.length}`);
    dot.addEventListener('click', () => {
      updateSlider(i);
    });
    indicatorsContainer.appendChild(dot);
  });

  const indicators = Array.from(indicatorsContainer.children);

  function updateSlider(index) {
    currentIndex = index;

    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    indicators.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  function initSlider() {
    updateSlider(0);
  }

  mediaList.addEventListener('touchstart', (e) => {
    if (window.innerWidth > 749) return;

    startY = e.touches[0].clientY;
    deltaY = 0;
    isDragging = false;
  });

  mediaList.addEventListener('touchmove', (e) => {
    if (window.innerWidth > 749) return;

    const currentY = e.touches[0].clientY;
    deltaY = startY - currentY;

    if (Math.abs(deltaY) > 5) { // make it more sensitive
      isDragging = true;

      const isAtLastSlide = currentIndex === slides.length - 1;
      const isAtFirstSlide = currentIndex === 0;
      const isSwipingUp = deltaY > 0;
      const isSwipingDown = deltaY < 0;

      const allowPageScroll =
        (isAtLastSlide && isSwipingUp) ||
        (isAtFirstSlide && isSwipingDown);

      if (!allowPageScroll) {
        e.preventDefault();  // Block page scroll & pull-to-refresh
      }
    }
  }, { passive: false });

  mediaList.addEventListener('touchend', () => {
    if (window.innerWidth > 749) return;
    if (!isDragging) return;

    if (Math.abs(deltaY) > 30) {
      if (deltaY > 0 && currentIndex < slides.length - 1) {
        updateSlider(currentIndex + 1);
      } else if (deltaY < 0 && currentIndex > 0) {
        updateSlider(currentIndex - 1);
      }
    }

    isDragging = false;
  });

  initSlider();
});
